import { render, staticRenderFns } from "./Schatting.vue?vue&type=template&id=d234c052&scoped=true"
import script from "./Schatting.vue?vue&type=script&lang=js"
export * from "./Schatting.vue?vue&type=script&lang=js"
import style0 from "./Schatting.vue?vue&type=style&index=0&id=d234c052&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d234c052",
  null
  
)

export default component.exports